import {PingCommand} from "./PingCommand";
import {Command} from "./Command";
import {GetTCDataCommand} from "./GetTCDataCommand";
import {AddEventListenerCommand} from "./AddEventListenerCommand";
import {RemoveEventListenerCommand} from "./remove-event-listener-command";
import {PrivateCommand} from "./PrivateCommand";
import {AddEventListenerPrivateCommand} from "./private/add-event-listener-private-command";
import {log} from "../../util/log";
import {ShowCMPPrivateCommand} from "./private/show-cmp-private-command";
import {ShowGdprPrivateCommand} from "./private/show-gdpr-private-command";
import {NeedAcquireConsentPrivateCommand} from "./private/need-acquire-consent-private-command";
import {GetCustomProvidersPrivateCommand} from "./private/get-custom-providers-private-command";
import {RemoveEventListenerPrivateCommand} from "./private/remove-event-listener-private-command";
import {GDPRAlreadyAccepted} from "./private/g-d-p-r-already-accepted";
import {isGDPRExcludedPrivateCommand} from "./private/is-g-d-p-r-excluded-private-command";
import {GetAcceptanceLevelPrivateCommand} from "./private/get-acceptance-level-private-command";
import {GetCMPInfo} from "./private/get-c-m-p-info";
import {RejectAndSaveConsents} from "./private/reject-and-save-consents";

class CommandBuilder {

    public static build(type:string) : Command|null
    {
        switch (type) {
            case 'ping':
                return new PingCommand();
            case 'getTCData':
                return new GetTCDataCommand();
            case 'addEventListener':
                return new AddEventListenerCommand();
            case 'removeEventListener':
                return new RemoveEventListenerCommand();
        }
        return null;
    }

    public static buildPrivate(type:string) : PrivateCommand|null
    {
        log.debug(`Building private message: ${type}`);
        switch (type) {
            case 'addEventListener':
                return new AddEventListenerPrivateCommand();
            case 'gdprAlreadyAccepted':
                return new GDPRAlreadyAccepted();
            case 'getAcceptanceLevel':
                return new GetAcceptanceLevelPrivateCommand();
            case 'getCMPInfo':
                return new GetCMPInfo();
            case 'getCustomProviders':
                return new GetCustomProvidersPrivateCommand();
            case 'needAcquireConsent':
                return new NeedAcquireConsentPrivateCommand();
            case 'removeEventListener':
                return new RemoveEventListenerPrivateCommand();
            case 'showCMP':
                return new ShowCMPPrivateCommand();
            case 'showGdpr':
                return new ShowGdprPrivateCommand();
            case 'isGDPRExcludedPrivateCommand':
                return new isGDPRExcludedPrivateCommand();
            case 'rejectAndSaveConsents':
                return new RejectAndSaveConsents();
        }
        return null;
    }

}

export {CommandBuilder}
